import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

function UserListFetchError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot get list of users'}
    </Alert>
  );
}

export { UserListFetchError };